export default {
  SET_OFFER_LIST: 'SET_OFFER_LIST',
  SET_ACTIVE_OFFER: 'SET_ACTIVE_OFFER',
  SET_EVENT_ID: 'SET_EVENT_ID',
};
